import React, { useState, useEffect } from 'react'

import { API_BASE_URL } from '../../config/api'

const PhotoModal = ({ photo, isClearTheme, onClose }) => {
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const checkMobile = () => {
      const mobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
                     window.innerWidth < 768
      setIsMobile(mobile)
    }
    checkMobile()
    window.addEventListener('resize', checkMobile)
    return () => window.removeEventListener('resize', checkMobile)
  }, [])

  if (!photo) return null

  return (
    <div
      className={`fixed inset-0 z-50 flex items-center justify-center p-4 ${
        isMobile
          ? 'bg-black/80'
          : isClearTheme
            ? 'bg-black/30 backdrop-blur-lg'
            : 'bg-black/80'
      }`}
      onClick={onClose}
    >
      <div
        className={`${isMobile ? 'bg-slate-900/95' : 'bg-white/20 backdrop-blur-xl'} rounded-2xl shadow-2xl border border-white/30 max-w-4xl w-full max-h-[90vh] overflow-y-auto`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="relative">
          <CloseButton onClick={onClose} />
          <PhotoDisplay photo={photo} />
          <PhotoInfo photo={photo} />
        </div>
      </div>
    </div>
  )
}

const CloseButton = ({ onClick }) => (
  <button
    onClick={onClick}
    className="absolute top-4 right-4 bg-black/50 hover:bg-black/70 text-white p-2 rounded-full transition-colors z-10"
  >
    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
    </svg>
  </button>
)

const PhotoDisplay = ({ photo }) => (
  <div className="relative p-6 pb-0">
    <img
      src={`${API_BASE_URL}${photo.path}`}
      alt={photo.customName || photo.originalName}
      className="w-full max-h-96 object-contain rounded-xl"
    />
  </div>
)

const PhotoInfo = ({ photo }) => (
  <div className="p-6">
    <div className="mb-4">
      <h3 className="text-2xl font-semibold mb-2" style={{ color: 'var(--theme-text-primary)' }}>
        {photo.customName || photo.originalName}
      </h3>
      <p className="text-lg" style={{ color: 'var(--theme-text-secondary)' }}>
        From: <span className="font-medium">{photo.eventName}</span>
      </p>
    </div>

    {photo.description && (
      <PhotoDescription description={photo.description} />
    )}

    {photo.uploadedAt && (
      <PhotoUploadDate date={photo.uploadedAt} />
    )}
  </div>
)

const PhotoDescription = ({ description }) => (
  <div className="mb-4">
    <h4 className="text-sm font-medium mb-2" style={{ color: 'var(--theme-text-primary)' }}>
      Description
    </h4>
    <p style={{ color: 'var(--theme-text-secondary)' }} className="text-sm leading-relaxed">
      {description}
    </p>
  </div>
)

const PhotoUploadDate = ({ date }) => (
  <div className="text-sm">
    <span className="font-medium" style={{ color: 'var(--theme-text-primary)' }}>Uploaded:</span>
    <p style={{ color: 'var(--theme-text-secondary)' }}>{new Date(date).toLocaleDateString()}</p>
  </div>
)

export default PhotoModal